import React from "react"

import { CustomAgentFailsToRespondConfig } from "@/metrics/registry/configuration"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { AgentFailsToRespondMetricRecord } from "./AgentFailsToRespondMetricRecord"

export class CustomAgentFailsToRespondMetricRecord extends AgentFailsToRespondMetricRecord {
  get hasVersionedConfig() {
    return true
  }

  // TODO: Version tracking should use runtime_metadata once structured runtime metadata is implemented.
  // max_silence_duration_seconds should move from result to runtime_metadata.
  isMetricOutputCurrentVersion(_metricOutput: {
    result_json?: Record<string, unknown> | null
  }): boolean {
    return true
  }

  getVersionDiff(_metricOutput: {
    result_json?: Record<string, unknown> | null
  }): Array<{ field: string; current: string; previous: string }> {
    return []
  }

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
  ): React.ReactNode {
    return (
      <CustomAgentFailsToRespondConfig
        metricRecordData={metricRecordData}
        onChange={onChange}
      />
    )
  }

  renderMetricType(): React.ReactNode {
    return "Agent Fails to Respond Delay"
  }
}
